/**
 * Popup video
 */

import $ from "jquery";

const $addToCart = $(".js--add-to-cart");
var isAjax = false;

$addToCart.on("submit", function (e) {
	e.preventDefault();
	const $this = $(this);
	let data = $this.serializeArray();
	data.push({ name: "action", value: "app_add_to_cart" });

	const settings = {
		url: resources.ajax,
		data,
		beforeSend: function () {
			isAjax = true;
		},
	};

	if (!isAjax) {
		$.ajax(settings)
			.done(function (response) {
				window.location.href = response.data.quote_url;
			})
			.fail(function (error) {
				console.log("Error:" + error);
			})
			.complete(function () {
				isAjax = false;
			});
	}
});

// Check if the current URL includes the word "quote"
// @TODO: add multi language support url is not quote on test preview f.e.

if (
	!window.location.href.includes("quote") ||
	!window.location.href.includes("offerte")
) {
	const $cartBar = $("#quote-bar");

	$(window).scroll(function () {
		const scrollPosition = $(this).scrollTop();

		if (scrollPosition >= 400) {
			$cartBar.removeClass("translate-y-[100%]");
		} else {
			$cartBar.addClass("translate-y-[100%]");
		}
	});
}
